"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchField = exports.SEARCH_FIELD_INPUT_ID = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
require("./SearchField.scss");
var SEARCH_FIELD_INPUT_ID = 'header-search-field-input';
exports.SEARCH_FIELD_INPUT_ID = SEARCH_FIELD_INPUT_ID;
var SearchField = function SearchField(_ref) {
  var onClick = _ref.onClick,
    onSubmit = _ref.onSubmit,
    onInputChange = _ref.onInputChange,
    onInputKeyDown = _ref.onInputKeyDown,
    onClearButtonClick = _ref.onClearButtonClick,
    onScanCodeButtonClick = _ref.onScanCodeButtonClick,
    hasScanCodeButton = _ref.hasScanCodeButton,
    value = _ref.value,
    isLoading = _ref.isLoading,
    placeholder = _ref.placeholder,
    deviceType = _ref.deviceType,
    inputRef = _ref.inputRef,
    dataAttributes = _ref.dataAttributes,
    className = _ref.className;
  var rootClassName = (0, _classnames["default"])('cds-SearchField', (0, _defineProperty2["default"])({}, "cds-SearchField--".concat((0, _upperCaseFirst.upperCaseFirst)(deviceType || '')), deviceType), className);
  return /*#__PURE__*/_react["default"].createElement("form", (0, _extends2["default"])({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName,
    role: "search",
    onSubmit: onSubmit
  }), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: SEARCH_FIELD_INPUT_ID
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-HideVisibility"
  }, "Search")), /*#__PURE__*/_react["default"].createElement("input", {
    autoComplete: "off",
    className: "cds-SearchField-TextInput",
    id: SEARCH_FIELD_INPUT_ID,
    onChange: onInputChange,
    onClick: onClick,
    onKeyDown: onInputKeyDown,
    placeholder: placeholder,
    ref: inputRef,
    type: "text",
    value: value
  }), hasScanCodeButton && /*#__PURE__*/_react["default"].createElement("button", {
    className: "cds-SearchField-ScanCodeButton",
    onClick: onScanCodeButtonClick,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-HideVisibility"
  }, "Scan Code"), /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.codeScanner
  })), value.length > 0 && isLoading && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: "cds-SearchField-IconLoader",
    name: _Icon.ICON_NAME.loader
  }), value.length > 0 && /*#__PURE__*/_react["default"].createElement("button", {
    className: "cds-SearchField-CloseButton",
    onClick: onClearButtonClick,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-HideVisibility"
  }, "Close Search"), /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.close
  })), /*#__PURE__*/_react["default"].createElement("button", {
    className: "cds-SearchField-SubmitButton",
    type: "submit"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-HideVisibility"
  }, "Submit Search"), /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.search
  })));
};
exports.SearchField = SearchField;